// extracted by mini-css-extract-plugin
module.exports = {"pagination-main":"Pagination_pagination-main__iTINE","paginationMain":"Pagination_pagination-main__iTINE"};